/**
 * Thin wrapper that mounts ScoringWorkspace inside the evaluation shell.
 * All scoring UI — CriteriaPanel, ScoreEntrySection (debounced matrix),
 * VisualizationPanel — lives in `components/scoring/ScoringWorkspace.tsx`
 * (E2 / MYD-207, supersedes cancelled MYD-136). The legacy single-column
 * layout is gone.
 */

import { useOutletContext } from 'react-router-dom'
import type { EvaluationOutletContext } from '../Evaluations_ShowCN'
import ScoringWorkspace from './scoring/ScoringWorkspace'

const EvaluationScoring = () => {
	const { evalId } = useOutletContext<EvaluationOutletContext>()
	return <ScoringWorkspace evalId={evalId} />
}

export default EvaluationScoring
